import Quill from 'quill';
const Link = Quill.import('formats/link');

const ATTRIBUTES = ['href', 'rel', 'target', 'class'];
class Format extends Link {
    static create(value) {
        let href;
        let rel = 'noopener noreferrer';
        let target = '_blank';

        let cls = '';
        if (typeof value === 'object') {
            if (value.href) href = value.href;
            if (value.rel) rel = value.rel;
            if (value.target) target = value.target;
            if (value.class) cls = value.class;
        } else if (typeof value === 'string') {
            href = value;
        }

        let node = super.create(href);
        href = this.sanitize(href);

        node.setAttribute('href', href);
        if (rel) node.setAttribute('rel', rel);
        if (target) node.setAttribute('target', target);
        if (cls) node.setAttribute('class', cls);

        return node;
    }

    // format(name, value) {
    //     if (name === this.statics.blotName) super.format(name, null);
    //     return super.format(name, value);
    // }

    static formats(node) {
        return ATTRIBUTES.reduce((formats, attribute) => {
            if (node.hasAttribute(attribute)) formats[attribute] = node.getAttribute(attribute);
            return formats;
        }, {});
    }
}

Format.blotName = 'link';
Format.tagName = 'A';

export default Format;
